import { useState, useEffect } from 'react';
import { Cookie, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const CONSENT_KEY = 'hc-cookie-consent';

export function CookieBanner() {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
      role="dialog"
      aria-label="Cookie-Einstellungen"
    >
      <div className="max-w-3xl mx-auto bg-[#0f172a] border border-slate-700 rounded-2xl shadow-[0_-4px_40px_rgba(0,0,0,0.5)] p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">

        {/* Icon */}
        <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center">
          <Cookie className="w-5 h-5 text-cyan-400" />
        </div>

        {/* Text */}
        <p className="flex-1 text-sm text-slate-300 leading-relaxed">
          {t.cookie.text}{' '}
          <Link
            to="/datenschutz"
            data-testid="cookie-privacy-link"
            className="text-cyan-400 hover:underline underline-offset-2"
            onClick={accept}
          >
            {t.cookie.privacy}
          </Link>
        </p>

        {/* Buttons */}
        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={decline}
            data-testid="cookie-decline-btn"
            className="px-4 py-2 rounded-lg text-sm font-medium text-slate-400 hover:text-white hover:bg-slate-700 transition-colors"
          >
            {t.cookie.decline}
          </button>
          <button
            onClick={accept}
            data-testid="cookie-accept-btn"
            className="px-5 py-2 rounded-lg text-sm font-semibold bg-cyan-500 text-slate-950 hover:bg-cyan-400 transition-colors shadow-[0_0_16px_rgba(0,188,212,0.3)]"
          >
            {t.cookie.accept}
          </button>
        </div>

        {/* Close */}
        <button
          onClick={decline}
          data-testid="cookie-close-btn"
          className="absolute top-3 right-3 text-slate-600 hover:text-slate-300 transition-colors"
          aria-label="Schließen"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
